import { styled, useTheme } from '@automata/mui-theme';
import Box, { BoxProps } from '@mui/material/Box';
import { useState } from 'react';

type Props = Omit<BoxProps, 'borderColor' | 'bgcolor'> & {
  isSelected?: boolean;
  width: number;
};

const HexagonSVG = styled('svg')<{
  width: number;
  height: number;
  fill: string;
  stroke: string;
}>`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  fill: ${(props) => props.fill};
  stroke: ${(props) => props.stroke};
  stroke-width: 2;
  transition: stroke-width 0.1s, stroke 0.1s;
  stroke-width: 2px;
  &.hovered {
    stroke: ${(p) => p.theme.palette.neutral[900]};
  }
  &.selected {
    stroke-width: 4px;
    stroke: ${(p) => p.theme.palette.neutral[900]};
  }
`;

const NodeBackground = ({
  children,
  width,
  isSelected = false,
  ...restBoxProps
}: Props): JSX.Element => {
  const theme = useTheme();
  const bgColorWithDefault = theme.palette.common.white;
  const borderColorWithDefault = theme.palette.neutral[400];
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      {...restBoxProps}
      sx={{
        position: 'absolute',
        overflow: 'visible',
        top: '50%',
        transform: 'translateY(-50%)',
        height: '100%',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <HexagonSVG
        width={width}
        height={76}
        fill={bgColorWithDefault}
        stroke={borderColorWithDefault ?? ''}
        viewBox={`-2 0 ${width + 10} 72`}
        className={[
          isSelected ? 'selected' : '',
          isHovered ? 'hovered' : '',
        ].join(' ')}
      >
        <polygon
          points={`18,0 ${width - 18},0 ${width},36 ${
            width - 18
          },72 18,72 0,36`}
        />
      </HexagonSVG>
    </Box>
  );
};

export default NodeBackground;
